/**
 * @generated SignedSource<<5d95c6c05dca2490d282351b72f829bf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Header_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableGroupByDropdown_GroupByDropdown_project">;
  readonly " $fragmentType": "main_issueNavigator_Header_project";
};
export type main_issueNavigator_Header_project$key = {
  readonly " $data"?: main_issueNavigator_Header_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_Header_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_issueTableGroupByDropdown_GroupByDropdown_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "d00af9ed7cb804b5da2f49ad3966e67c";

export default node;
